<template lang="html">
  <v-dialog v-model="dialogwallpaper" max-width="500px" persistent max-height="550px" style="overflow-y: hidden; border-radius: 20px !important;">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
            <v-layout row wrap>
              <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;
              <p class="mb-0">{{$t('Dialog.wallpaper.headerWallpaper')}}</p>
            </v-layout>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon flat @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text class="" style="height: 550px !important; overflow-y: hidden;">
        <v-layout column wrap justify-center align-center>
          <vue-avatar
            :image="imageData"
            :width="450"
            :height="450"
            :rotation="rotation"
            :scale="scale"
            :border="0"
            ref="vueavatar"
            @vue-avatar-editor:image-ready="onImageReady"
            style="border: solid thin #eee; height: 300px; margin-bottom: 10px; background-image: url(https://image.flaticon.com/icons/png/512/1250/1250734.png); background-size: 100px, 100px, cover; background-position: center;"
          >
        </vue-avatar>
          <br>
          <v-slider
            v-model="scale"
            label="Zoom :"
            min=1
            max=3
            step=0.02
            thumb-label="always"
            ticks
          ></v-slider>
          <v-slider
            v-model="rotation"
            label="Rotation :"
            min=0
            max=360
            step=1
            thumb-label="always"
            ticks
          ></v-slider>

            <!-- <div class="image-preview" v-if="imageData.length > 0">
              <img class="preview" :src="imageData">
            </div>
            <div class="file-upload-form">
                Upload an image file:
                <input type="file" @change="previewImage($event)" accept="image/*" id="uppic">
            </div> -->
            <!-- <v-btn @click="saveClicked">Get image</v-btn> -->
        </v-layout>
        <v-layout row wrap justify-end align-center>
          <v-btn @click="saveClicked()" class="btnwallpaper" :disabled="!check">{{$t('AnswerQuestion.setbackground')}}</v-btn>
          <v-btn @click="resetbg()"class="btnresetwallpaper">{{$t('AnswerQuestion.resetbackground')}}</v-btn>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import PictureInput from 'vue-picture-input'
import { Momenttime, Decode } from '@/services'
import { VueAvatar } from 'vue-avatar-editor-improved'
import { sync } from 'vuex-pathify'
var _ = require('lodash')
export default {
  name: 'app',
  props: {
    dialogwallpaper: false
  },
  components: {
    PictureInput,
    VueAvatar
  },
  computed: {
    ...sync('*')
  },
  data: () => ({
    rotation: 0,
    scale: 1,
    tokenuser: '',
    tokenroom: '',
    imageData: '',
    wallpaperInfo: {
      info:
      [
        {
          room: '',
          background: ''
        }
      ]
    },
    check: false,
    img: 'https://image.flaticon.com/icons/png/512/118/118246.png',
    canvasWidth: 0,
    canvasHeight: 0
  }),
  created() {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.tokenuser = decoded['tokenuser']
    this.tokenroom = this.$route.params.roomid
  },
  methods: {
    resetbg () {
      this.$swal({
        type: 'warning',
        text: this.$t('Alert.Right.removeWallpaper'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#999999',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
          var room = this.$route.params.roomid
          var index = _.findIndex(wallpaper.info, function (o) { return o.room === room })
          wallpaper.info.splice(index, 1)
          localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
          this.$swal('', this.$t('Alert.Success.deletebackground'), 'success')
          this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
          this.closeDialog()
        }
      })
    },
    uppic () {
      // console.log('obj')
      $('#uppic').click()
    },
    saveClicked () {
      // var img = this.$refs.vueavatar.getImage()
      // this.$refs.image.src = img.toDataURL();
      // this.setbg(img.toDataURL())
      const vm = this
      const canvas = this.$refs.vueavatar.getImageScaled()
      canvas.toBlob(function(blob){
        const reader = new FileReader()
        reader.onload = (e) => {
          vm.imageData = e.target.result
          vm.setbg(vm.imageData)
        }
        reader.readAsDataURL(blob)
      })
    },
    onImageReady () {
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.check = true
      this.scale = 1
      this.rotation = 0
    },
    previewImage (event) {
      // console.log(event)
      var input = event.target
      // console.log(input.files)
      // console.log(input.files[0])
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    setbg (img) {
      this.imageData = img
      // console.log(this.imageData)
      // console.log(this.$refs.vueavatar.getImageScaled())
      // this.img = this.$refs.vueavatar.getImageScaled()
      // this.imageData = this.img.toDataURL()
      var wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
      var room = this.$route.params.roomid
      var index = _.findIndex(wallpaper.info, function (o) { return o.room === room })
      if (index === -1) {
        wallpaper.info.push({
          room:  this.$route.params.roomid,
          background: this.imageData
        })
        localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
      } else {
        wallpaper.info.splice(index, 1)
        wallpaper.info.push({
          room:  this.$route.params.roomid,
          background: this.imageData
        })
        localStorage.setItem('wallpaperInfo', JSON.stringify(wallpaper))
      }
      this.imageData = ''
      this.$swal('', this.$t('Alert.Success.setbackground'), 'success')
      this.closeDialog()
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
    },
    closeDialog () {
      // console.log(this.imageData)
      // this.canvasWidth = 0
      // this.canvasHeight = 0
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      this.$refs.vueavatar.state.image.resource = null
      this.check = false
      this.scale = 1
      this.rotation = 0
      this.imageData = ''
      this.$emit('closeWallpaper', false)
    },
    onChange () {
      console.log('New picture selected!')
      if (this.$refs.pictureInput.image) {
        console.log('Picture loaded.')
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    }
  },
  watch: {
    '$route.params.roomid' () {
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', JSON.stringify(this.wallpaperInfo))
      }
    },
    dialogwallpaper () {
      // console.log(obj);
      this.check = false
      this.imageData = ''
      var canvas = document.getElementById('avatarEditorCanvas')
      var context = canvas.getContext('2d')
      context.clearRect(0, 0, canvas.width, canvas.height)
      if (JSON.parse(localStorage.getItem('wallpaperInfo')) === null) {
        localStorage.setItem('wallpaperInfo', JSON.stringify(this.wallpaperInfo))
      }
    }
  }
}
</script>

<style lang="css" scoped>
.btnwallpaper {
  background-color: #2196f3 !important;
  color: white !important;
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 7px !important;
  width: 130px !important;
  box-shadow: none !important;
  /* border-color: #3896f3 !important; */
}
.btnresetwallpaper {
  background-color: #ffff !important;
  color: #3896f3 !important;
  border-style: solid !important;
  border-width: thin !important;
  border-radius: 7px !important;
  width: 130px !important;
  border-color: #3896f3 !important;
  box-shadow: none !important;
}

.preview {
  width: 300px;
  height: 300px;
  object-fit: cover;
  object-position: 50% 0;
}
.btnalbums {
  width: 100px !important;
  border-style: solid !important;
  border-radius: 20px !important;
  border-width: thin !important;
  border-color: inherit !important;
  background-color: #2196f3 !important;
  color: white !important;
  text-transform: none;
}
>>>.v-dialog .v-dialog--active .v-dialog--persistent {
  border-radius: 20px !important;
}
>>>.v-list .v-list--two-line .theme--light {
  width: 100% !important;
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/wallpaper/wallpaper_dialog.vue